import React from 'react';
import PropTypes from 'prop-types';
import styles from './BackTop.module.scss';
import history from '../../../utils/history';

const BackTop = ({ text = '' }) => {
  const backIcon = (
    <svg fill="#14133A" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" />
    </svg>
  );

  return (
    <div className={styles.navPanel}>
      <button type="button" onClick={() => history.goBack()} className={styles.navPanelBack}>
        {backIcon} Back
      </button>

      <span className={styles.navPanelBorder} />

      {text}
    </div>
  );
};

export default BackTop;

BackTop.propTypes = {
  text: PropTypes.string,
};
